import React from 'react';
import './FullScreenImage.css'
import { Image } from '../Message Components';

const FullScreenImage = ({ imageUrl, nextImage, prevImage }) => {
  return (
    //   <img src={imageUrl} alt="Full Screen" />
    // </div>
    <div className="full-screen-image">
      {/* <span class="material-symbols-outlined cursor-pointer" onClick={prevImage}>
        arrow_back_ios
      </span> */}
      <div className="full-screen-image__container">
        {/* <Image link={imageUrl} size="lg" /> */}
        <img className="full-screen-image__img" src={imageUrl} size="lg" />
      </div>
      {/* <span class="material-symbols-outlined cursor-pointer" onClick={nextImage}>
        arrow_forward_ios
      </span> */}
    </div>
  );
};

export default FullScreenImage;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ImageLibrary/FullScreenImage.js